import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

import { 
  makeStyles 
} from '@material-ui/core/styles';

import {
  Avatar,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Collapse,
  Divider,
  Grid,
  IconButton,
  Menu,
  MenuItem,
  Typography,
} from '@material-ui/core';

import {
  ExpandMore as ExpandMoreIcon,
  MoreVert as MoreIcon,
  ViewQuilt as CloudFormationStackIcon,
  Assessment as CloudWatchDashboardIcon,
  OpenInNew as ExtLinkIcon,
} from '@material-ui/icons';

import {
  UserContext,
} from '../../user';

import {
  DetailPanel,
  FieldValue,
} from '../../../packages/detail-panel';

import {
  ResourceAction,
  ResourceRef,
  ResourcePolyIcon, 
} from '.';

import { 
  fmtDashboardLink,
  fmtIso8601AsLocalDateTime,
  fmtStackFilterLink,
  fmtTitleCase,
} from '../../utils/formatters';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  sections: {
    padding: theme.spacing(0),
    display: 'flex',
    overflow: 'auto',  // this was causing horizontal scrollbar on resource cards
    flexDirection: 'row',
  },
  section: {
    padding: theme.spacing(1),
    minWidth: 300,
    flexGrow: 1,
  },
  expand: {
    transform: 'rotate(0deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),
  },
  expandOpen: {
    transform: 'rotate(180deg)',
  },
  menuLabel: {
    padding: theme.spacing(1),
  }
}));

export default function ResourceCard(props) {
  const { resource, fields, stack, dashboard, expansion, expansionProps, actions } = props;
  const classes = useStyles();

  const [expanded, setExpanded] = React.useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleActionMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };
  // const handleActionMenuClose = () => {
  //   setAnchorEl(null);
  // };

  // const handleActionClick = (action) => {
  //   handleActionMenuClose();
  //   if(action.onClick) {
  //     action.onClick(action.value);
  //   }
  // };

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  // const handleGoToDashboard = (name) => {
  //   window.open(fmtDashboardLink(name),"_blank");
  // };
  
  // const handleGoToStack = (name) => {
  //   window.open(fmtStackFilterLink(name),"_blank");
  // };

  const userContext=React.useContext(UserContext); 

  // const standardActions=[];
  // const isAdmin = userContext.role==='Admin';
  // if ( isAdmin && dashboard && resource.Dashboard==='ENABLED' ) {
  //   standardActions.push({ name: 'Go to Dashboard', icon: CloudWatchDashboardIcon, value: resource.StackName, onClick: handleGoToDashboard, external: true });
  // }
  // if ( isAdmin && stack ) {
  //   standardActions.push({ name: 'Go to Stack', icon: CloudFormationStackIcon, value: resource.StackName, onClick: handleGoToStack, external: true });
  // }
  // const divider=(standardActions.length&&actions.length)?[{divider: true}]:[];
  // const effectiveActions=[...actions, ...divider, ...standardActions];

  if (!resource) return(null);

  const specifiedFields=fields ? fields : [
    { name: "ResourceId", label: "ID", component: FieldValue, options: { maxLength: 40 } }, 
    { name: "ClientAccountId", label: "Client", component: ResourceRef, options: { type: 'Client', linked: resource.ResourceType!=='Client' } },
    { name: "StackCreated", label: "Created", formatter: fmtIso8601AsLocalDateTime },
    { name: "StackUpdated", label: "Updated", formatter: fmtIso8601AsLocalDateTime },
  ];

  // gather unsectioned fields into a default section
  const sections=[];
  const unsectionedFields=[];
  specifiedFields.forEach(field => {
    if(field.section) {
      sections.push(field);
    } else {
      unsectionedFields.push(field);
    }
  });
  if(unsectionedFields.length) {
    sections.push({
      section: "", fields: unsectionedFields
    });
  }

  const ExpansionComponent=expansion?expansion:null;
  
  return (
    <Card className={classes.root}>
      <CardHeader 
        avatar={
          <Avatar aria-label="type" className={classes.avatar}>
            <ResourcePolyIcon type={resource.ResourceType}/>
          </Avatar>
        }
        action=<ResourceAction 
          resource={resource} 
          view={false} 
          actions={actions}
        />
        title={(resource.ResourceSubtype?(resource.ResourceSubtype+" "):"")+fmtTitleCase(resource.ResourceType)}
        subheader={resource.Description?resource.Description:"No Description"}
      />
      <CardContent>
        <Grid container className={classes.sections}>
          {
            sections.map((section, index) => {
              return(
                <Grid key={"s"+index} item className={classes.section} >
                  <DetailPanel 
                    name={section.section} 
                    data={resource}
                    fieldWidth='600px'
                    {...section}
                  />
                </Grid>
              );
            })
          }
        </Grid>
      </CardContent>
      { expansion?
        <React.Fragment>
          <CardActions disableSpacing>
            <IconButton
              className={clsx(classes.expand, {
                [classes.expandOpen]: expanded,
              })}
              onClick={handleExpandClick}
              aria-expanded={expanded}
              aria-label="show more"
            >
              <ExpandMoreIcon />
            </IconButton>
          </CardActions>
          <Collapse in={expanded} timeout="auto" unmountOnExit>
            <ExpansionComponent {...expansionProps}/>
          </Collapse>
        </React.Fragment>:null
      }
    </Card>
  );
}

ResourceCard.propTypes = {
  resource: PropTypes.object,
  fields: PropTypes.array,
  stack: PropTypes.bool.isRequired,
  dashboard: PropTypes.bool.isRequired,
  actions: PropTypes.array.isRequired,
  expansion: PropTypes.func,
  expansionProps: PropTypes.object
};

ResourceCard.defaultProps = {
  stack: true,
  dashboard: true,
  actions: []
};
